module.exports = __webpack_public_path__ + "static/media/portfolio (20).0f0774ed.jpg";